/**
 * Class representing the fl_three_save object.
 */
class save_pics {

    /**
     * Constructor for creating a new instance of the class.
     *
     * @param {string} container_id - The id of the canvas element.
     */
    constructor(container_id) {
        this.cropping = false;
        this.container_id = container_id;
        this.canvas = $('#' + this.container_id + ' canvas')[0];
    }

    /**
     * Build a download/upload file name for a product image.
     *
     * @param {string} title
     * @return {string}
     */
    static buildFileName(title) {
        return title + '.png';
    }

    /**
     * Saves the canvas as a file with the specified name.
     * If cropping is enabled, crops the canvas before saving.
     *
     * @param {string} file_name - The name of the file to save.
     * @returns {Promise<void>} - A promise that resolves once the file is saved.
     */
    async save(file_name) {
        var data_url = await this.get_data_url();
        let downloadLink = document.createElement('a');
        downloadLink.setAttribute('download', file_name);
        let url = data_url.replace(/^data:image\/png/, 'data:application/octet-stream');
        downloadLink.setAttribute('href', url);
        downloadLink.click();
    }

    async get_data_url () {
        var data_url = this.canvas.toDataURL('image/png');

        if (this.cropping) {
            data_url = await this.crop(data_url, this.canvas.width, this.canvas.height);
        }

        return data_url;
    }

    async upload(product) {
        var data_url = await this.get_data_url();
        var product_id = product.woo_id;

        if (!product_id) {
            return Promise.reject(new Error('Missing product ID'));
        }

        var datatosend = {
            'img': data_url,
            'file_name': save_pics.buildFileName(product.title),
            'product_id': product_id,
            'sub_action': 'save_thumb',
            'action': "fl_save_pics",
            'security': texts.security
        };

        return $.ajax({
            url: texts.ajaxurl,
            data: datatosend,
            type: 'post',
        }).then(function (result) {
            var thumbUrl = typeof result === 'string' ? result.trim() : '';
            if (!thumbUrl || thumbUrl === 'false' || thumbUrl.indexOf('http') !== 0) {
                return Promise.reject(new Error('Upload failed'));
            }
            return thumbUrl;
        });
    }

    /**
     * Crop the image represented by the data URL to the specified canvas width and height.
     *
     * @param {string} data_url - The data URL of the image to be cropped.
     * @param {number} canvas_width - The width of the canvas to crop the image.
     * @param {number} canvas_height - The height of the canvas to crop the image.
     * @return {Promise<string>} A promise that resolves to the cropped data URL.
     */
    async crop(data_url, canvas_width, canvas_height) {
        var self = this;
        return new Promise(function (resolve, reject) {
            var img = new Image;
            img.onload = function () {
                var canvas = document.createElement('canvas');
                canvas.width = canvas_width;
                canvas.height = canvas_height;
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                document.body.appendChild(canvas);
                var data_url_cropped = self.get_cropped_data_url(canvas);
                resolve(data_url_cropped);
            };
            img.src = data_url;
        });
    }

    /**
     * Returns the data URL of a cropped image from the provided canvas.
     *
     * @param {HTMLCanvasElement} canvas - The canvas element containing the original image.
     *
     * @return {string} - The data URL of the cropped image.
     */
    get_cropped_data_url(canvas, extraPadding = 10) {
        var context = canvas.getContext('2d');
        var w = canvas.width, h = canvas.height, pix = {x: [], y: []},
            imageData = context.getImageData(0, 0, canvas.width, canvas.height), x, y, index, w_before = canvas.width,
            h_before = canvas.height;

        // Get the boundary pixels of the cropped area
        for (y = 0; y < h; y++) {
            for (x = 0; x < w; x++) {
                index = (y * w + x) * 4;
                if (imageData.data[index + 3] > 0) { // check if the pixel is not transparent
                    pix.x.push(x);
                    pix.y.push(y);
                }
            }
        }

        pix.x.sort(function (a, b) { return a - b });
        pix.y.sort(function (a, b) { return a - b });
        var n = pix.x.length - 1;

        if (n < 0) {
            return canvas.toDataURL('image/png');
        }

        // Calculate cropped width and height
        var croppedW = 1 + pix.x[n] - pix.x[0];
        var croppedH = 1 + pix.y[n] - pix.y[0];

        // Determine the side length for the square (max of width and height) and add extra padding
        var side = Math.max(croppedW, croppedH) + extraPadding * 2;

        // Get the cropped image data
        var cut = context.getImageData(pix.x[0], pix.y[0], croppedW, croppedH);

        // Set the canvas to a square size with padding and center the cropped image
        canvas.width = side;
        canvas.height = side;
        context.clearRect(0, 0, side, side);

        // Calculate offsets to center the image with padding
        var offsetX = (side - croppedW) / 2;
        var offsetY = (side - croppedH) / 2;
        context.putImageData(cut, offsetX, offsetY);

        // Get the data URL of the square, centered image
        var data_url = canvas.toDataURL('image/png');

        // Restore the original canvas dimensions
        canvas.width = w_before;
        canvas.height = h_before;

        return data_url;
    }

}
